import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { AppProvider } from './context/AppContext';
import Layout from './components/layout/Layout';
import Login from './components/auth/Login';
import HomePage from './components/home/HomePage';
import Dashboard from './components/dashboard/Dashboard';
import Teams from './components/teams/Teams';
import Registrations from './components/registrations/Registrations';
import Payments from './components/payments/Payments';
import Tournaments from './components/tournaments/Tournaments';
import Schedule from './components/schedule/Schedule';
import Brackets from './components/brackets/Brackets';
import Messages from './components/messages/Messages';
import Store from './components/store/Store';
import Highlights from './components/highlights/Highlights';
import AdminEditor from './components/admin/AdminEditor';

function ProtectedRoute({ children, adminOnly }) {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== 'admin') return <Navigate to="/dashboard" replace />;
  return <Layout>{children}</Layout>;
}

function AppRoutes() {
  const { user } = useAuth();
  return (
    <Routes>
      <Route path="/"           element={<HomePage />} />
      <Route path="/login"      element={user ? <Navigate to="/dashboard" replace /> : <Login />} />
      <Route path="/dashboard"     element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/teams"         element={<ProtectedRoute><Teams /></ProtectedRoute>} />
      <Route path="/registrations" element={<ProtectedRoute><Registrations /></ProtectedRoute>} />
      <Route path="/payments"      element={<ProtectedRoute><Payments /></ProtectedRoute>} />
      <Route path="/tournaments"   element={<ProtectedRoute><Tournaments /></ProtectedRoute>} />
      <Route path="/schedule"      element={<ProtectedRoute><Schedule /></ProtectedRoute>} />
      <Route path="/brackets"      element={<ProtectedRoute><Brackets /></ProtectedRoute>} />
      <Route path="/messages"      element={<ProtectedRoute><Messages /></ProtectedRoute>} />
      <Route path="/store"         element={<ProtectedRoute><Store /></ProtectedRoute>} />
      <Route path="/highlights"    element={<ProtectedRoute><Highlights /></ProtectedRoute>} />
      <Route path="/admin"         element={<ProtectedRoute adminOnly><AdminEditor /></ProtectedRoute>} />
      <Route path="*"              element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppProvider>
          <AppRoutes />
        </AppProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
